module.exports = __webpack_public_path__ + "static/media/zodiac-book-cover.636518d9.jpg";